import lazyWithRetry from '@shared/lib/lazyWithRetry';

import Loadable from '@components/Loadable/Loadable.tsx';
import { SuperAdminProtectedRoute } from '@providers/SuperAdminProtectedRoute/ui/SuperAdminProtectedRoute';

const DocumentPromptPreviewCreatePage = Loadable(
  lazyWithRetry(
    () =>
      import('@pages/SuperAdminPanelPage/DocumentPromptPreviewPage/create.tsx')
  )
);
const DocumentPromptPreviewUpdatePage = Loadable(
  lazyWithRetry(
    () =>
      import('@pages/SuperAdminPanelPage/DocumentPromptPreviewPage/update.tsx')
  )
);

const DocumentPromptPreviewChildRoutes = {
  path: 'admin/document-prompt-preview',
  element: <SuperAdminProtectedRoute />,
  children: [
    { path: 'create', element: <DocumentPromptPreviewCreatePage /> },
    { path: 'edit/:id', element: <DocumentPromptPreviewUpdatePage /> },
  ],
};

export default DocumentPromptPreviewChildRoutes;
